export const homeQueryKeys = {
  all: ["home"] as const,
  activeCampaignDistribution: (clientId?: string) =>
    [
      ...homeQueryKeys.all,
      "active-campaign-distribution",
      clientId ?? null,
    ] as const,
  activeCampaignIntegrationCount: (clientId?: string) =>
    [
      ...homeQueryKeys.all,
      "active-campaign-integration-count",
      clientId ?? null,
    ] as const,
  segmentMembershipHistoryBatch: (
    segmentIds: string[],
    from: string,
    to: string,
    clientId?: string,
  ) =>
    [
      ...homeQueryKeys.all,
      "segment-membership-history-batch",
      segmentIds,
      from,
      to,
      clientId ?? null,
    ] as const,
};
